import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { VendorService } from 'src/app/_services/vendor.services';
import { SnackbarService } from 'src/app/_service/message-service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _moment from 'moment';
import { default as _rollupMoment } from 'moment';
import { MomentDateAdapter } from '@angular/material-moment-adapter'
import { TranslateService } from '@ngx-translate/core';
import { phoneNumberValidator } from 'lac-mat-tel-input';
import { AuthenticationService, UserService } from 'src/app/_services';
import { UserInfoService } from 'src/app/_services/userInfo.service';
import { ActualRole, Role } from 'src/app/util/enums/role.enum';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { Subscription } from 'rxjs';
import { ManageMappingService } from '../user-management/services/manage-mapping.service';
import { MenuRouteID } from '../header/menu-item/nav-item';
import { countries } from 'src/app/util/enums/countries.enum';

const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'telio-create-operator-details',
  templateUrl: './create-operator-details.component.html',
  styleUrls: ['./create-operator-details.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class CreateOperator implements OnInit {
  createVendor: FormGroup;
  submitted = false;
  numberAllow: string;
  showAdminCount = false;
  vendordetails: any;
  subscriptions = new Subscription();
  clicked = false;
  userName: RegExp = /^[a-zA-Z0-9]+$/;
  mobileNumbers: RegExp = /^[6-9]\d{9}$/;
  emailRegEX: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@,"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  passwordRegEX: RegExp = /^((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W]).{8,15})$/;
  testdata = '';
  countries = ['us', 'in'];
  @Input() vendorId;
  @Input() editVendor;
  @Input() fromCmsUser;
  @Output() formSubmitted = new EventEmitter<void>();
  startDate: Date;
  endDate: Date;
  accountId;
  numbers: RegExp = /^[0-9]*$/;
  countryList = [];
  stateList = [];
  cityList = [];
  userDetails: any = {};
  adminrole: any;
  tenantadminrole: any;
  iscreate = true;
  @Input() listedCountries
  selectedcountry;
  country;
  state;
  city;
  partyId;
  userId;
  groupHierarchyList = [];
  filteredParentIds = [];
  routedComponent: string;
  groupType;
  countryValue = 'country'
  countryDisplayValue = 'country_description'
  stateValue = 'iso2';
  stateDisplayValue = 'name';
  cityValue = 'name';
  cityDisplayValue = 'name';
  defaultCountryData = {
    "country": "IN",
    "country_description": "India",
  };
  prefCountry = '';
  prefCountryMobile = [];
  checkedBeforeSubmit = false;
  title;
  isMyProfile = false;
  nextyearDate;
  groupName;
  vendorlist: any = [];
  driverId;
  stationmangerid;
  stateId;
  stateLabel: string = 'createCpo.state';
  cityLabel: string = 'createCpo.city';

  constructor(
    private formBuilder: FormBuilder,
    private vendorservice: VendorService,
    private router: Router,
    readonly manageMappingService: ManageMappingService,
    private toastr: SnackbarService,
    public translate: TranslateService,
    private route: ActivatedRoute,
    private userService: UserService,
    private userInfoService: UserInfoService,
    private authService: AuthenticationService,
  ) {
  }

  ngOnInit() {
    if (!!this.createVendor) { this.createVendor.reset() };
    const cpoGroup = [ActualRole.CPO, ActualRole.SUBCPO];
    this.groupHierarchyList = this.userInfoService.isAdminGroup() ? [cpoGroup[0]] : [cpoGroup[1]];
    this.userInfoService.userDetails.prefCountry === 'LK' ? (this.stateLabel = 'createCpo.province') : (this.stateLabel = 'createCpo.state');
    this.userInfoService.userDetails.prefCountry === 'LK' ? (this.cityLabel = 'createCpo.district') : (this.cityLabel = 'createCpo.city');
    this.title = !!this.userInfoService.userDetails.appTitle ? this.userInfoService.userDetails.appTitle : 'TELIOEV'
    this.prefCountry = !!this.userInfoService.userDetails.prefCountry ? this.userInfoService.userDetails.prefCountry : this.defaultCountryData.country
    this.prefCountryMobile = [this.prefCountry.toLowerCase()];
    this.groupHierarchy();
    this.countryList = this.userInfoService.countryList;
    // if(!!this.editVendor){
    //   this.getvendorinfobyvendorid();
    // }
    this.getvendorinfobyvendorid();
    // setTimeout(() => {
    //   if(!!this.editVendor){
    //     this.getvendorinfobyvendorid();
    //   }
    // }, 2000); 
    this.route.queryParams.subscribe(params => {
      this.routedComponent = params['routedName'];
      this.isMyProfile = params['isMyProfile'];
    });
    this.userDetails = this.userInfoService.userDetails;
    this.adminrole = this.userInfoService.isAdminGroup();
    this.tenantadminrole = this.userInfoService.groups.includes(Role.SUPERADMIN)
    this.nextyearDate = new Date();
    this.nextyearDate.setDate(this.nextyearDate.getDate() + 364);

    if (this.editVendor) {
      this.startDate = new Date(this.editVendor.amc_start_date)
      this.endDate = new Date(this.editVendor.amc_end_date)
      this.iscreate = false;
    } else {
      this.getStates(this.prefCountry);
      this.getDefaultCountryData();
    }
    this.createVendor = this.formBuilder.group({
      vendor_name: [{ value: this.editVendor ? this.editVendor.username : null, disabled: this.editVendor ? true : false }, Validators.compose([
        Validators.required])],
      vendor_email: [{ value: this.editVendor ? this.editVendor.email : null, disabled: this.editVendor ? true : false }, Validators.compose([
        Validators.required,
        Validators.pattern(this.emailRegEX)
      ])],
      vendor_mobile: [this.editVendor ? this.editVendor.country_code + ' ' + this.editVendor.mobile : null, Validators.compose([
        Validators.required,
        phoneNumberValidator
      ])],
      location: [this.editVendor ? this.editVendor.address : '', Validators.required],
      city: [this.editVendor ? this.editVendor.city : '', Validators.required],
      state: [this.editVendor ? this.getStateName(this.editVendor.state) : '', Validators.required],
      country: [this.editVendor ? this.getCountryName(this.editVendor.country) : this.defaultCountryData.country_description, Validators.required],
      pincode: [this.editVendor ? this.editVendor.pincode : '', [Validators.required, Validators.pattern(this.numbers)]],
      address2: [this.editVendor ? this.editVendor.address2 : ''],
      start_date: [{ value: this.editVendor ? this.startDate : new Date(), disabled: true }, Validators.required],
      end_date: [{ value: this.editVendor ? this.endDate : this.nextyearDate, disabled: true }, Validators.required],
      partyId: [{ value: this.editVendor ? this.editVendor.party_id : '', disabled: this.editVendor ? true : false }, Validators.compose([Validators.required, Validators.pattern('[A-Za-z]+'), Validators.minLength(3)])],
      dataSharing: [this.editVendor ? this.editVendor.data_sharing : false],
      //organizationName: [ this.editVendor ? this.editVendor.organizationName : '' , Validators.required],
    });
    this.createVendor.get('country').valueChanges.subscribe((countryValue) => {
      if (!countryValue) {
        this.createVendor.get('state').setValue('');
        this.editVendor && (this.editVendor.state = '')
        this.createVendor.get('city').setValue('');
        this.editVendor && (this.editVendor.city = '')
      }
    });

    this.createVendor.get('state').valueChanges.subscribe((stateValue) => {
      if (!stateValue) {
        this.createVendor.get('city').setValue('');
        this.editVendor && (this.editVendor.city = '')
      }
    });

    this.createVendor.get('state').valueChanges.subscribe((stateValue) => {
      if (!stateValue) {
        this.createVendor.get('city').setValue('');
        this.cityList=[]
        this.editVendor && (this.editVendor.city = '')
      }
    })
    if (!this.fromCmsUser) {
      // this.createVendor.addControl('partyId',new FormControl( { value: this.editVendor ? this.editVendor.partyId : '', disabled: this.editVendor ? true : false }, Validators.compose([Validators.required, Validators.pattern('[A-Za-z]+'), Validators.minLength(3)])))
      this.createVendor.addControl('organizationName', new FormControl(this.editVendor ? this.editVendor.organization_name : '', Validators.required))
    }
    if (this.fromCmsUser) {
      // this.createVendor.addControl('partyId',new FormControl( { value: this.editVendor ? this.editVendor.partyId : '', disabled: this.editVendor ? true : false }, Validators.compose([Validators.required, Validators.pattern('[A-Za-z]+'), Validators.minLength(3)])))
      this.createVendor.addControl('group', new FormControl(!!this.editVendor ? (!!this.editVendor.group ? this.getGroupType(this.editVendor.group) : '') : '', Validators.required))
      if (this.adminrole) {
        this.createVendor.addControl('vendorId', new FormControl('', Validators.required))
        if (this.editVendor) {
          this.onGroupSelectionChange(this.getGroupType(this.editVendor.group))
        }
      }
    }
    if (this.vendorId && this.editVendor){
      this.getvendorinfobyvendorid();
    }

    if (this.editVendor && this.editVendor.country){
      this.getStates(this.editVendor.country);
    if (this.editVendor && this.editVendor.country && this.editVendor.state){
      this.getCities(this.editVendor.state);
    }
    }  
  }


  onSubmit() {
    this.submitted = true;
    let headers = { headers: { 'Accept-Version': 'V2'} }
    // stop here if form is invalid
    if (this.createVendor.valid) {
      this.clicked = true;
      if (this.createVendor.value.vendor_name == 0) {
        this.toastr.error(this.translate.instant('createVendor.validMsg1'));
        return;
      }
      else if (this.createVendor.value.vendor_email == 0) {
        this.toastr.error(this.translate.instant('createVendor.validMsg2'));
        return;
      }
      else if (this.createVendor.value.vendor_mobile == 0) {
        this.toastr.error(this.translate.instant('createVendor.validMsg3'));
        return;
      }
      else if (this.createVendor.value.location == 0) {
        this.toastr.error(this.translate.instant('createVendor.validMsg4'));
        return;
      }
      else if (this.createVendor.value.start_date == 0) {
        this.toastr.error(this.translate.instant('createVendor.validMsg5'));
        return;
      }
      else if (this.createVendor.value.end_date == 0) {
        this.toastr.error(this.translate.instant('createVendor.validMsg6'));
        return;
      }
      this.vendordetails = this.createVendor.value;
      let countrycode = this.vendordetails.vendor_mobile.split(' ')[0];
      // the service for create vendor is changed so need to use signup service only for create vendor
      let input: any = {
        "username": this.vendordetails.vendor_name,
        "email": this.vendordetails.vendor_email,
        "role": "vendor",
        "mobile_no": this.vendordetails.vendor_mobile.replace(countrycode + ' ', '').replace(/[.*\-?^${}()|[\]\\]/g, '').replace(/ /g, ''),
        "address": this.vendordetails.location,
        "address2": this.vendordetails.address2,
        "city": this.city,
        "state": this.authService.normalizeState(this.state),
        "country": this.country,
        "pincode": this.vendordetails.pincode,
        "amc_start_date": new Date().toISOString(),
        "amc_end_date": this.nextyearDate.toISOString(),
        "country_code": countrycode,
        "country_initials": this.selectedcountry,
        // "group": this.vendordetails.group,
       "data_sharing": this.vendordetails.dataSharing ? this.vendordetails.dataSharing : false
      }


      let stDate = new Date(this.vendordetails.start_date);
      let edDate = new Date(this.vendordetails.end_date);
      if (!this.fromCmsUser) {
          input.organization_name = this.vendordetails.organizationName,
          input.group = this.userInfoService.isAdminGroup() ? 'CPO' : 'SubCpo'

      }
      if (this.fromCmsUser) {
        input.group = this.vendordetails.group;
        input.vendor_id = this.editVendor ? this.stationmangerid : this.vendordetails.vendorId;
      }
      if (!this.vendorId) {
        input.party_id = this.vendordetails.partyId.toUpperCase()
        this.vendorservice.createvendor(input,headers).subscribe(
          (resp: any) => {
            switch (resp.status_code) {
              case 409:
                if (resp.body) {
                  this.toastr.error(resp.body);
                } else {
                  this.toastr.error(resp.status_message);
                  this.clicked = false;
                }
                break;
              case 400:
                this.toastr.error(resp.status_message);
                this.clicked = false;
                break;
              default:
                if (!!resp) {
                  this.toastr.success(resp.status_message);
                  this.clicked = true;
                  this.vendorId = this.vendordetails.vendor_email;
                  this.getvendorinfobyvendorid();
                  this.authService.setVendorID(true);
                  this.authService.setCreatedOperatorId(this.vendordetails.vendor_email);
                  this.authService.setCmsUserID(resp.userId);
                  this.formSubmitted.emit();
                } else {
                  this.toastr.error(resp.message);
                }
                break;
            }
          },
          error => {
            this.clicked = false;
            this.toastr.error(error.message);
          });
      }
      else {
        input.vendor_id = this.vendorId;
        input.name = this.editVendor.name;
        input.status = "active";
        input.password = this.editVendor.password;
        input.party_id = this.vendordetails.partyId;
        this.vendorservice.updatevendor(input,headers).subscribe(
          (resp: any) => {
            if (!!resp) {
              this.toastr.success(this.translate.instant('rfid.successUpdate'))
              this.authService.setVendorID(true)
              this.authService.setCreatedOperatorId(this.vendordetails.vendor_email)
              this.reDirectButton();
            }
          },
          error => {
            this.clicked = false;
            this.toastr.error(error.message);
          }
        );
      }
    }
  }

  resetmethod(createVendor, formDirective) {
    this.createVendor.markAsPristine();
    this.createVendor.markAsUntouched();
    this.createVendor.controls['vendor_name'].reset();
    this.createVendor.controls['vendor_mobile'].reset();
    this.createVendor.controls['vendor_email'] && this.createVendor.controls['vendor_email'].reset();
    this.createVendor.controls['location'].reset();
    this.createVendor.controls['city'].reset();
    this.createVendor.controls['state'].reset();
    this.createVendor.controls['country'].reset();
    this.createVendor.controls['pincode'].reset();
    this.createVendor.controls['address2'].reset();
    this.createVendor.controls['partyId'].reset();
    !!this.createVendor.controls['organizationName'] && this.createVendor.controls['organizationName'].reset()
  }

  groupHierarchy() {
    this.manageMappingService.groupHierarchy().subscribe(res => {
    this.groupHierarchyList = !!res ? res : [];
    })
  }

  getGroupType(group) {
    let commaIndex = group.indexOf(',');
    if (commaIndex !== -1) {
      return group.slice(0, commaIndex).trim()
    } else {
      return group;
    }
  }

  getvendorinfobyvendorid() {
    this.vendorservice.getvendorinfobyvendorid(this.vendorId, this.groupType).subscribe(res => {
      if (res.status_code != "500" && this.vendorId) {
        this.editVendor = res;
        if(this.editVendor && !!res && this.vendorId){
          this.createVendor.get('vendor_name').disable(); 
          this.createVendor.get('partyId').disable(); 
          this.createVendor.get('vendor_email').disable(); 
        }
        if (this.editVendor && this.editVendor.country) {
          this.getStates(this.editVendor.country);
        }
        this.city = !!this.editVendor ? (!!this.editVendor.city?this.editVendor.city : '') : '' ;
        this.driverId = this.editVendor.parent_id;
        var nextyearDate = new Date();
        nextyearDate.setDate(nextyearDate.getDate() + 364);
        this.startDate = new Date(this.editVendor.amc_start_date);
        this.endDate = new Date(this.editVendor.amc_end_date);
        this.createVendor.controls['vendor_name'].setValue(this.editVendor ? this.editVendor.name : null);
        this.createVendor.controls['vendor_name'].updateValueAndValidity();
        this.createVendor.controls['vendor_email'].setValue(this.editVendor ? this.editVendor.vendor_id : null);
        this.createVendor.controls['vendor_email'].updateValueAndValidity();
        this.createVendor.controls['vendor_mobile'].setValue(this.editVendor ? this.editVendor.country_code + ' ' + this.editVendor.mobile_no : null);
        this.createVendor.controls['vendor_mobile'].updateValueAndValidity();
        this.createVendor.controls['location'].setValue(this.editVendor ? this.editVendor.address : null);
        this.createVendor.controls['location'].updateValueAndValidity();
        this.createVendor.controls['country'].setValue(this.editVendor ? this.getCountryName(this.editVendor.country) : null);
        this.createVendor.controls['country'].updateValueAndValidity();
        this.createVendor.controls['pincode'].setValue(this.editVendor ? this.editVendor.pincode : null);
        this.createVendor.controls['pincode'].updateValueAndValidity();
        this.createVendor.controls['address2'].setValue(this.editVendor ? this.editVendor.address2 : null);
        this.createVendor.controls['address2'].updateValueAndValidity();
        this.createVendor.controls['start_date'].setValue(this.editVendor ? this.startDate : new Date());
        this.createVendor.controls['start_date'].updateValueAndValidity();
        this.createVendor.controls['end_date'].setValue(this.editVendor ? this.endDate : nextyearDate);
        this.createVendor.controls['end_date'].updateValueAndValidity();
        this.createVendor.controls['partyId'].setValue(this.editVendor ? this.editVendor.party_id : null);
        this.createVendor.controls['partyId'].updateValueAndValidity();
        this.createVendor.controls['dataSharing'].setValue(this.editVendor ? this.editVendor.data_sharing : false);
        this.createVendor.controls['dataSharing'].updateValueAndValidity();
        if (!this.fromCmsUser) {
          this.createVendor.controls['organizationName'].setValue(this.editVendor ? this.editVendor.organization_name : null);
          this.createVendor.controls['organizationName'].updateValueAndValidity();
        }
      }
    })
  }
  
  countrySelected(event) {
    this.selectedcountry = event.flagClass;
  }

  getStates(event) {
    this.country = event;
    this.cityList = [];
    if (this.country == countries.NEPAL) {
      this.userService.getStateForNepal().subscribe((res: any) => this.handleStateResponse(res))
    }
    else if (this.country == countries.SRILANKA) {
      this.userService.getStateForSriLanka().subscribe((res: any) => this.handleStateResponse(res))
    }
    else {
      this.userService.getStates(this.country).subscribe((res: any) => this.handleStateResponse(res));
    }
  }

  handleStateResponse(res: any) {
    if (!!res) {
      this.stateList = res;
      if (this.editVendor && this.editVendor.country && this.editVendor.state) {
        const normalizedState = this.authService.reverseNormalizeState(this.editVendor.state)
        this.createVendor.controls['state'].setValue(this.editVendor ? this.getStateName(normalizedState) : null);
        this.createVendor.controls['state'].updateValueAndValidity();
        this.getCities(this.editVendor.state);
      }
    }
  }

  getCities(event) {
    this.state = this.authService.reverseNormalizeState(event)
    if (this.country === countries.NEPAL) {
      let stateObj = this.stateList.find(res => res.iso2 === event)
      this.stateId = stateObj.iso2
      this.userService.getCitiesForNepal(this.stateId).subscribe((res: any) => {
        if (!!res) {
          this.cityList = res;
          if (this.editVendor && this.editVendor.country && this.editVendor.state && this.editVendor.city) {
            this.createVendor.controls['city'].setValue(this.editVendor ? this.editVendor.city : null);
            this.createVendor.controls['city'].updateValueAndValidity();
          }
        }
      })
    }
    else if (this.country === countries.SRILANKA) {
      let stateObj = this.stateList.find(res => res.iso2 === event)
      this.stateId = stateObj.iso2
      this.userService.getCitiesForSriLanka(this.stateId).subscribe((res: any) => {
        if (!!res) {
          this.cityList = res;
          if (this.editVendor && this.editVendor.country && this.editVendor.state && this.editVendor.city) {
            this.createVendor.controls['city'].setValue(this.editVendor ? this.editVendor.city : null);
            this.createVendor.controls['city'].updateValueAndValidity();
          }
        }
      })
    }
    else {
      this.userService.getCities(this.country, this.state).subscribe((res: any) => {
        if (!!res) {
          this.cityList = res;
          if (this.editVendor && this.editVendor.country && this.editVendor.state && this.editVendor.city) {
            this.createVendor.controls['city'].setValue(this.editVendor ? this.editVendor.city : null);
            this.createVendor.controls['city'].updateValueAndValidity();
          }
        }
      })
    }
  }

  convertToUppercase(event: any) {
    event.target.value = event.target.value.toUpperCase();
  }

  setCity(event) {
    this.city = event;
  }

  backButton() {
    !this.adminrole && this.vendorId ? this.router.navigate(['/dashboard/home']) : this.reDirectButton();
  }

  reDirectButton() {
    this.routingScreen();
  }

  routingScreen() {
    if (this.routedComponent == 'operators') {
      this.router.navigate(['/dashboard/operators', { routeID: this.route.snapshot.paramMap.get('routeID') }])
    }
    else if (this.routedComponent == 'home') {
      this.router.navigate(['/dashboard/home', { routeID: MenuRouteID.HOME }])
    }
    else {
      this.router.navigate(['/dashboard/user-management/users', { routeID: this.route.snapshot.paramMap.get('routeID') }])
    }
  }

  getCountryName(country) {
    let countryObj = this.countryList.find(res => res.country === country)
    return !!countryObj ? countryObj.country_description : ''
  }
  getStateName(state) {
    let stateObj = this.stateList.find(res => res.iso2 === this.authService.reverseNormalizeState(state))
    return !!stateObj ? stateObj.name : ''
  }

  getDefaultCountryData() {
    this.defaultCountryData = this.countryList.find(country => country.country === this.prefCountry);
    return this.defaultCountryData;
  }

  formValidate(): boolean {
    return (this.createVendor.valid && !!this.state && !!this.country && this.city)
  }

  checkBoxStatus(event) {
    return this.checkedBeforeSubmit = event.checked;
  }

  onGroupSelectionChange(selectedGroup: string): void {
    if (selectedGroup.toLocaleLowerCase() === Role.OPERATOR || (this.createVendor.get('group').value).toLocaleLowerCase() === Role.OPERATOR || selectedGroup.toLocaleLowerCase() === Role.STATIONMANAGER || (this.createVendor.get('group').value).toLocaleLowerCase() === Role.STATIONMANAGER) {
      this.groupName = [ActualRole.CPO, ActualRole.SUBCPO];
      this.manageMappingService.getUserByGroup(1, 1000, '', 'asc', '', this.groupName)
        .subscribe((resp: any) => {
          this.vendorlist = resp.content;
          !!this.vendorlist && this.vendorlist.forEach((ele: any, i: number) => {
            this.filteredParentIds.push({
              'username': this.vendorlist[i].username,
              'email': this.vendorlist[i].user_email,
              'userId': this.vendorlist[i].user_id
            })
          });
          if (this.editVendor) {
            this.getUsernameByEmail(this.driverId, this.filteredParentIds)
          }
        });
    }
    else {
      this.groupName = [ActualRole.CPO, ActualRole.ADMIN, ActualRole.SUBCPO];
      this.manageMappingService.getUserByGroup(1, 1000, '', 'asc', '', this.groupName)
        .subscribe((resp: any) => {
          this.vendorlist = resp.content;
          !!this.vendorlist && this.vendorlist.forEach((ele: any, i: number) => {
            this.filteredParentIds.push({
              'username': this.vendorlist[i].username,
              'email': this.vendorlist[i].user_email,
              'userId': this.vendorlist[i].user_id
            })
          });
          if (this.editVendor) {
            this.getUsernameByEmail(this.driverId, this.filteredParentIds)
          }
        });
    }
  }

  getUsernameByEmail(id, userArray) {
    const user = userArray.find(userObj => userObj.userId.toString() === id);
    if (user) {
      this.stationmangerid = user.email,
      this.createVendor.get('vendorId').setValue(user.email);
      this.createVendor.controls.vendorId.updateValueAndValidity();
    } else {
      return null;
    }
  }

isConditionMet(): boolean {
  return !this.tenantadminrole && !this.isMyProfile && !this.fromCmsUser;
}
}

